
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
   Flits(document).on("Flits:Navigation:Loaded", function (e) {
    var t = e.detail.settings,
        n = { title: "FAQ", url: "https://www.huntersdale.com/pages/frequently-asked-questions", target: 1, badge: null, icon: null, isShow: 1, loader: null, body_html: null };
    t.navs.splice(4, 0, n);
  }),
    Flits(document).on("Flits:SocialLogin:Loaded", function (e) {
    setTimeout(function () {
      location.pathname.indexOf("/account") == -1 && Flits.setLocalStorage("flits_before_login_url", "/account");
    }, 800);
  }),
    Flits(window).load(function () {
    location.pathname.indexOf("/account") == -1 && (location.pathname.indexOf("checkout") != -1 ? Flits.setLocalStorage("flits_before_login_url", location.pathname) : Flits.setLocalStorage("flits_before_login_url", "/account"));
  }),
    Flits(document).on("Flits:AccountPage:Loaded", function (e) {
    var t = e.detail;
    t.settings.active_tab = "#order";
  });
  Flits(document).on('Flits:Navigation:Loaded', function(event){
    var settings = event.detail.settings;
    var obj = {
      title: 'Manage my subscription order',
      url:'/tools/recurring/login',
      target:1,
      badge: null,
      icon: null,
      isShow: 1,
      loader:null,
      body_html: ''
    }
    settings.navs.splice(2, 0, obj);
  });
}(Flits));
